<template>
  <div class="home-layout discover-layout" :class="modeClass">
    <header v-if="!$route.meta.noHeader" class="home-layout-header-row">
      <event-app-layout-header />
    </header>
    <div v-if="!$route.meta.noHeader" class="filter-section">
      <cltn-type-filter-comp class="type-filter"/>
      <event-sort-filter-comp />
    </div>
    <section>
      <router-view />
      <CommonFooter />
    </section>
  </div>

</template>

<script lang="ts">
import {computed, defineComponent} from 'vue';
import EventAppLayoutHeader from '@/components/layout/event_app_layout/EventAppLayoutHeader.vue';
import CltnTypeFilterComp from '@/components/pages/discover/comp/CltnTypeFilterComp.vue';
import EventSortFilterComp from '@/components/pages/discover/comp/EventSortFilterComp.vue';
import {store} from '@/store';
import {useRoute} from 'vue-router';
import {useHomeListConfig} from '@/script/homeScript';
import CommonFooter from '@/components/layout/CommonFooter.vue';

export default defineComponent({
  name: 'DiscoverLayout.vue',
  components: {
    CommonFooter,
    EventAppLayoutHeader,
    CltnTypeFilterComp,
    EventSortFilterComp,
  },
  setup() {
    const route = useRoute()
    const modeClass = computed(() => {
      if (route.name === 'HomeView') return store.getters['status/getNftListClass']
      return 'status-able'
    })
    const {
      viewMode,
    } = useHomeListConfig()
    return {
      modeClass,
      viewMode,
    }
  }
})
</script>
